export const colors = {
  JIO_PRIMARY_ALPHA: '#DF9F39',
  BUTTON_BLUE: '#CD3D00',
  ITEM_HOVER: '#0070B60A',
  HOVER_SOLID: '#FCF5ED',
  DASHBOARD_BLUE: '#0070B614',
  HIGHLIGHT: '#CD3D00',
  HOVER_BG: '#24397A0A',
  DISABLED_GREY: '#00000029',
}
